import { Component, Input, OnInit } from "@angular/core";
import { ControlPanelMenuItem } from "./control-panel-menu-item.model";

@Component({
    selector: "kno2-control-panel",
    templateUrl: "./control-panel.component.html",
    styleUrls: ["./control-panel.component.scss"],
    standalone: false
})
export class ControlPanelComponent implements OnInit {
    @Input() public renderAsGrid = false;
    @Input() public sidebarItems: Array<ControlPanelMenuItem>;
    public expandedPanels: Array<string> = [];

    public get items(): Array<ControlPanelMenuItem> {
        return this.sidebarItems?.filter((i) => !i.disabled);
    }

    public ngOnInit(): void {
        this.expandedPanels = this.items?.map((item) => item.title) ?? [];
    }
}
